import $ from 'jquery';

const $modalWarning = $('.js-modal-warning');
const $modalTimeout = $('.js-modal-timeout');
const $countdownMin = $('.js-countdown-min');
const $countdownSec = $('.js-countdown-sec');

const timeoutSec = window.sessionTimeout * 60;
const timeoutMs = timeoutSec * 1000;

const untilWarning = timeoutMs * .8;
const fromWarningUntilTimeout = timeoutSec * .2;

let warningTimeout;
let countdownId;

let remainingSecondsLooped;

export function clear() {
    if (typeof warningTimeout !== 'undefined') window.clearTimeout(warningTimeout);
    if (typeof countdownId !== 'undefined') window.clearInterval(countdownId);
}

function setRemainingText(remainingSeconds) {
    const minutes = parseInt(remainingSeconds / 60, 10);
    const secs = remainingSeconds % 60;

    $countdownMin.text(minutes);
    $countdownSec.text(secs);
}

export function resetTimers() {
    clear();

    warningTimeout = window.setTimeout(function () {
        $modalWarning.modal('show');

        remainingSecondsLooped = fromWarningUntilTimeout;

        setRemainingText(remainingSecondsLooped);

        countdownId = window.setInterval(function () {
            remainingSecondsLooped--;

            if (remainingSecondsLooped < 1) {
                clear();
                const $form = $('<form id="timeout" action="/umbraco/surface/loginsurface/logout?timeout=1" method="POST"></form>');
                $('body').append($form);
                $form.submit();
            }

            setRemainingText(remainingSecondsLooped);

        }, 1000);
    }, untilWarning);
}

export function initEvents() {
    if (window.location.search.indexOf('timeout') > -1) {
        $modalTimeout.modal('show');
        window.history.replaceState({}, document.title, window.location.pathname);
    }

    $('.js-btn-warning').on('click', function () {
        clear();

        $.post('/umbraco/Surface/SessionSurface/extend', {})
            .done(function () { resetTimers(); })
            .fail(function () { window.location.reload(); });
    });

    resetTimers();
}

export default {
    initEvents,
    resetTimers,
    clear
};
